import { render, staticRenderFns } from "./counter-checkout.vue?vue&type=template&id=37571836&scoped=true"
import script from "./counter-checkout.vue?vue&type=script&lang=js"
export * from "./counter-checkout.vue?vue&type=script&lang=js"
import style0 from "./counter-checkout.vue?vue&type=style&index=0&id=37571836&prod&scoped=true&lang=css"
import style1 from "./counter-checkout.vue?vue&type=style&index=1&id=37571836&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37571836",
  null
  
)

export default component.exports